import { AlignmentType, Paragraph, TextRun } from 'docx';
import { mathToPlainText, normalizeMathInput } from './mathMixedText';

export type DocxFieldParagraphOptions = {
  prefix?: string;
  prefixBold?: boolean;
  alignment?: (typeof AlignmentType)[keyof typeof AlignmentType];
  indentLeft?: number;
  spacingBefore?: number;
  spacingAfter?: number;
  textColor?: string;
  textItalics?: boolean;
  textBold?: boolean;
};

/**
 * DOCX chỉnh sửa được: công thức chuyển sang Unicode / ký hiệu gần giống (mathToPlainText).
 * Không nhúng ảnh — không phát sinh request, sửa trực tiếp trong Word.
 */
export function createPlainMathParagraphs(text: string, options: DocxFieldParagraphOptions = {}): Paragraph[] {
  const normalized = normalizeMathInput(text ?? '');
  const lines = normalized.split(/\r?\n/);
  const paragraphs: Paragraph[] = [];

  for (let lineIndex = 0; lineIndex < lines.length; lineIndex += 1) {
    const line = lines[lineIndex];
    const plain = mathToPlainText(line);
    const children: TextRun[] = [];

    if (lineIndex === 0 && options.prefix) {
      children.push(
        new TextRun({
          text: options.prefix,
          bold: options.prefixBold ?? false,
          color: options.textColor,
          italics: options.textItalics,
        }),
      );
    }

    if (plain) {
      children.push(
        new TextRun({
          text: plain,
          color: options.textColor,
          italics: options.textItalics,
          bold: options.textBold,
        }),
      );
    }

    if (!children.length) {
      children.push(new TextRun(''));
    }

    paragraphs.push(
      new Paragraph({
        children,
        alignment: options.alignment,
        indent: options.indentLeft ? { left: options.indentLeft } : undefined,
        spacing: {
          before: options.spacingBefore,
          after: options.spacingAfter,
        },
      }),
    );
  }

  return paragraphs;
}
